/**
 * Хранение токенов.
 *
 * Access живёт только в памяти вкладки. Refresh — в localStorage: другого варианта нет,
 * пока сервер отдаёт его в теле ответа, а не в HttpOnly-cookie. Ключ общий для вкладок,
 * изменения слушаются через событие storage, чтобы вход и выход синхронизировались.
 */

export const REFRESH_TOKEN_KEY = 'unit1.admin.refreshToken';

export interface JwtPayload {
  sub: string;
  type: 'access' | 'refresh';
  jti: string;
  iat: number;
  exp: number;
}

let accessToken: string | null = null;

export function getAccessTokenRaw(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function readRefreshToken(): string | null {
  try {
    return window.localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function writeRefreshToken(token: string | null): void {
  try {
    if (token) {
      window.localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  } catch {
    // Приватный режим или заблокированное хранилище: сессия проживёт до перезагрузки.
  }
}

/** Разбор payload без проверки подписи — она на сервере. Клиенту нужны sub и exp. */
export function decodeJwt(token: string): JwtPayload | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;

    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );

    const parsed = JSON.parse(json) as JwtPayload;
    return typeof parsed?.sub === 'string' && typeof parsed?.exp === 'number' ? parsed : null;
  } catch {
    return null;
  }
}

/** Запас, чтобы не отправить запрос с токеном, истекающим в полёте. */
const EXPIRY_SKEW_SECONDS = 30;

export function secondsUntilExpiry(token: string): number {
  const payload = decodeJwt(token);
  if (!payload) return 0;
  return payload.exp - EXPIRY_SKEW_SECONDS - Math.floor(Date.now() / 1000);
}

export function isExpired(token: string): boolean {
  return secondsUntilExpiry(token) <= 0;
}
